import { render } from "./TheBotErrorsAlert.vue?vue&type=template&id=bde00aa0"
import script from "./TheBotErrorsAlert.vue?vue&type=script&lang=js"
export * from "./TheBotErrorsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__